import React, { useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { currentLanguage } from "../../i18n";
import Header from "../../components/Header/Header";
import FooterSection from "../../components/FooterSection/FooterSection";
import { t } from "../../i18n";

const blogs = [
  {
    id: 1,
    title: t("blogList.blog1.title"),
    description: t("blogList.blog1.content"),
    date: t("blogList.blog1.date"),
    image: "/images/blog-1.svg",
  },
  {
    id: 2,
    title: t("blogList.blog2.title"),
    description: t("blogList.blog2.content"),
    date: t("blogList.blog2.date"),
    image: "/images/blog-2.svg",
  },
  {
    id: 3,
    title: t("blogList.blog3.title"),
    description: t("blogList.blog3.content"),
    date: t("blogList.blog3.date"),
    image: "/images/blog-3.svg",
  },
];

const BlogListSection: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const solutionsRef = useRef<HTMLDivElement>(null);
  const blogRef = useRef<HTMLDivElement>(null);
  const contactRef = useRef<HTMLDivElement>(null);
  const missionRef = useRef<HTMLDivElement>(null);
  const pressRef = useRef<HTMLDivElement>(null);
  const testimonialRef = useRef<HTMLDivElement>(null);
  const showcaseRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const currentPath = location.pathname;
    const currentHash = location.hash;

    if (!currentPath.match(/^\/[a-z]{2}(\/|$)/)) {
      const newPath = `/${currentLanguage}${currentPath === "/" ? "" : currentPath}${currentHash}`;
      window.history.replaceState(null, "", newPath);
    }
  }, [location.pathname, location.hash]);

  const goToDetail = (id: number) => {
    navigate(`/${currentLanguage}/blog/${id}`);
  };

  return (
    <div>
      <Header />

      <section className="py-16 px-4 sm:px-6 md:px-20 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-800 mb-8 sm:mb-12 text-center">{t("blogList.title")}</h2>

          <div className="grid gap-8 sm:gap-10 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
            {blogs.map((blog) => (
              <div
                key={blog.id}
                className="bg-white rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300 cursor-pointer flex flex-col"
                onClick={() => goToDetail(blog.id)}
              >
                <img src={blog.image} alt={blog.title} className="w-full object-cover rounded-t-xl" />
                <div className="p-4 sm:p-6 flex flex-col justify-between h-full">
                  <h3 className="text-lg sm:text-xl font-semibold text-gray-800 mb-2 sm:mb-3">{blog.title}</h3>
                  <p className="text-gray-600 text-sm sm:text-base mb-3 sm:mb-4 line-clamp-3">{blog.description}</p>
                  <p className="text-sm text-gray-500 mb-2">{blog.date}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <FooterSection
        missionRef={missionRef}
        pressRef={pressRef}
        testimonialRef={testimonialRef}
        blogRef={blogRef}
        showcaseRef={showcaseRef}
        solutionsRef={solutionsRef}
        contactRef={contactRef}
      />
    </div>
  );
};

export default BlogListSection;
